import type { UploadSuccessAction, VideoType } from 'lib/media-upload-file';
import { useCallback } from 'react';
import type { FormInstance } from 'ui';
import { useUpdateVideoMutation } from '../../../../../queries';

type P = {
  form: FormInstance;
  formName: string;
  initiateFileUpload: ({ file, onSuccessAction }: { file: File; onSuccessAction: UploadSuccessAction }) => void;
  type: VideoType;
};

export const useStartUpload = ({ form, formName, initiateFileUpload, type }: P) => {
  const { mutate: updateVideo } = useUpdateVideoMutation();

  return useCallback(
    ({ file }: { file: File }) => {
      initiateFileUpload({
        file,
        onSuccessAction({ id, ref }) {
          updateVideo({ data: { [type]: { externalId: id } }, id: ref });
        },
      });

      form.setFieldsValue({
        [formName]: [
          {
            name: file.name,
            percent: 0,
            status: 'uploading',
            uid: type,
          },
        ],
      });
    },
    [initiateFileUpload, updateVideo, form, formName, type],
  );
};
